import { defineAction } from '~/prix'
import { z } from 'zod'
import benefitProgramFetchAction from './benefitProgramFetch.action.json' with { type: 'json' }
import { benefitProgramObject } from '../benefitProgramObject'

const benefitProgramFetchDefinition = defineAction({
  ...benefitProgramFetchAction,

  input: z.object({ id: benefitProgramObject.shape.id }),
  output: benefitProgramObject,
})

export default benefitProgramFetchDefinition
